module.exports = __webpack_public_path__ + "img/zhiyuanpinggu1.6391bbb9.png";